import { computeBaseline } from '../../../utils/analysisStatistics'

export const isSparklineAnomaly = (points?: number[]): boolean => {
  if (!points || points.length < 3) return false

  const { mean, stddev } = computeBaseline(points)
  if (stddev === 0) return false

  const threshold = 2 * stddev
  for (let index = 0; index < points.length; index += 1) {
    if (Math.abs(points[index] - mean) <= threshold) continue

    const left = index > 0 ? points[index - 1] : null
    const right = index < points.length - 1 ? points[index + 1] : null
    const leftFlat = left === null || Math.abs(left - mean) <= 0.5 * stddev
    const rightFlat = right === null || Math.abs(right - mean) <= 0.5 * stddev
    if (leftFlat && rightFlat) continue

    return true
  }

  return false
}
